import update from 'react-addons-update';
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../Order.sass';
import Order13RemarksAddPhoto from './Order13RemarksAddPhoto';
import {
  addOrderImage,
  updateOrderDetailInfoAction,
} from '../../../actions/order';

class Order13Remarks extends React.Component {
  static propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    addOrderImage: PropTypes.func.isRequired,
    modelDataText: PropTypes.shape().isRequired,
    updateOrderDetailInfoAction: PropTypes.func.isRequired,
    fieldParentName: PropTypes.string.isRequired,
    fieldChildName: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      imageComponent: [],
      index: 0,
    };
  }

  addImageComponent(isFromAddButton) {
    // first add image
    if (isFromAddButton) {
      if (this.props.images.length < 1) {
        this.state.imageComponent.push(
          <Order13RemarksAddPhoto
            key={`${this.props.images.length} ${new Date().toISOString()}`}
            addImageComponent={this.addImageComponent}
            removeImageComponent={this.removeImageComponent}
            index={this.props.images.length}
            setIsImgTooLarge={this.setIsImgTooLarge}
          />,
        );
        this.props.addOrderImage({});
        this.setState({ index: this.state.index + 1 });
      }
    } else if (this.props.images.length <= 10) {
      this.state.imageComponent.push(
        <Order13RemarksAddPhoto
          key={`${this.props.images.length} ${new Date().toISOString()}`}
          addImageComponent={this.addImageComponent}
          removeImageComponent={this.removeImageComponent}
          index={this.props.images.length - 1}
          setIsImgTooLarge={this.setIsImgTooLarge}
        />,
      );
      this.setState({ index: this.state.index + 1 });
    }
  }
  removeImageComponent(index) {
    this.setState({
      imageComponent: update(this.state.imageComponent, {
        $splice: [[index, 1]],
      }),
    });
  }

  render() {
    return (
      <div className={s2.order13RemarkLineHeight}>
        <span className={s2.orderSmallTitle}>
          {this.props.modelDataText.order_remark_title}
        </span>
        <Input
          type="textarea"
          name="text"
          id="exampleText"
          rows="4"
          placeholder={
            typeof this.props.modelDataText.order_remark_body !== 'undefined'
              ? this.props.modelDataText.order_remark_body
              : this.props.modelDataText.uniform_invoice_remark_input
          }
          style={{ backgroundColor: '#f6f6f6', border: '0px' }}
          onChange={e => {
            this.props.updateOrderDetailInfoAction(
              this.props.fieldParentName,
              this.props.fieldChildName,
              e.target.value,
            );
          }}
        />
      </div>
    );
  }
}
const mapState = state => ({
  images: state.order.images,
});
const mapDispatch = {
  addOrderImage,
  updateOrderDetailInfoAction,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(Order13Remarks),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order13Remarks/Order13Remarks.js